import React, {useState, useEffect} from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import Divider from "@mui/material/Divider";
import { GetPhotoProfile } from "../User/Infrastructure/User.presenter";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 591,
    height: 213,
    padding: '22px 42px 15px 22px',
    display: "flex",
    justifyContent: "space-around",
    gap: "18px",
  },
  avatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    gap: 11,
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "10px"
  },
  style:{
    display:"flex",
    alignItems:"center",
    justifyContent: "flex-start",
  },
  text: {
    fontWeight: 500,
    fontSize: "1.125rem",
  },
  title: {
    color: "#333333",
    textAlign: "left"
  },
  content: {
    color: "#4F4F4F",
  },
  description: {
    fontWeight: 400,
    color: "#4F4F4F",
    fontSize: "0.875rem",
    paddingTop: "18px",
    textAlign: "left"
  },
}));

export default function SocioCard({id, userName, date, stars, description, avatar, typeUser}) {
  const classes = useStyles();
  const [photo, setPhoto] = useState({});
  const [photoR, setPhotoR] = useState(false);

  const getUrlPhoto = async (urlPhoto) =>{
    const res = await GetPhotoProfile(urlPhoto);
    setPhoto(res);
    setPhotoR(true);
  }

  useEffect(() => {
    if(avatar){
      getUrlPhoto(avatar);
    }
  }, [avatar]);

  return (
    <Card className={classes.root} sx={{ borderRadius: "2px",  boxShadow: "none" }}>
        <div className={classes.avatar}>
            <span style={{display: "inline-block",width: 8, height: 8, background: "#EA5B13", borderRadius: "50%"}}/>
            <Avatar alt={userName} sx={{width:56, height:56 }} src={photoR && photo}  />
        </div>

        <div style={{width: "100%"}}>
            <div className={classes.headerContent}>
                <div>
                    <h3 className={`${classes.title} ${classes.text}`}>
                      {userName}
                    </h3>
                    <div className={classes.style}>
                        <h3 className={`${classes.content} ${classes.text}`}>
                            {stars}<StarRateRoundedIcon sx={{width:14, height:14, marginRight: "19px"}}/>
                        </h3>
                        <h3 className={`${classes.content} ${classes.text}`}>
                            {typeUser === "customers" && "Cliente"}
                            {typeUser === "deliveryman" && "Repartidor"}
                            {typeUser === "afiliador" && "Asesor comercial"}
                        </h3>
                    </div>
                </div>

                <p className={`${classes.content} ${classes.text}`}>{date}</p>
            </div>
        
            <Divider />
            <p className={classes.description}>
                {description}
            </p>
        </div>
    </Card>
  );
}
